<template>
  <div class="requirement-analysis">
    <!-- 组件内容 -->
    <div style="width: 1080px;padding: 40px 0 65px" class="flex-column items-center justify-center">
      <div class="title-box">
        <div class="ai-icon"></div>
        <div class="title-icon"></div>
      </div>
      <div class="title-message">上传需求，帮您快速拆解需求寻找技术成果</div>
      <div class="content-bg">
        <div class="content-box">
          <!-- 左侧 -->
          <div class="input-content flex-column items-center justify-between" style="padding-right: 14px" :style="{width: this.questionId ? '50%' : '100%'}">
            <el-input
              type="textarea"
              resize="none"
              placeholder="您可以在这里描述您的需求，例如：
需求面向产业方向是：xxxxxxxxxxxxxxx；主要解决问题是：xxxxxxxxxxxxxxx；需求方案描述：xxxxxxxxxxxxxxxxxx；
请推荐几家潜在的可以合作的机构。"
              v-model="textarea"
            />
            <div class="upload-btn" v-if="questionId">
              <el-button :loading="keyWordLoading" @click="getDemandDisassembly" :style="{padding: this.questionId ? '8px 14px !important' : '10px 14px !important'}" >立即识别</el-button>
            </div>
          </div>
          <!-- 分割线 -->
          <div style="height:100%;width: 0;background: transparent;border-left: 1px dashed #EDEDED" v-if="questionId"></div>
          <!-- 右侧  element-loading-background="rgba(255, 255, 255, 0.9)"-->
          <div class="input-content flex-column items-center justify-between" style="padding-left: 14px;padding-right: 14px" v-if="questionId" v-loading="keyWordLoading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <div class="right-top" style="width: 100%;flex-shrink: 0">
              <div style="color: #3860F4" class="flex items-center">
                <img src="@/assets/images/GuoJiao/question-icon.png" :height="13" :width="15" style="margin-right: 5px" alt=""/>
                基于大模型的技术需求拆解
              </div>
              <div class="descContent" ref="descContent" style="max-height: 186px;padding: 7px 0">
                <div class="field-content" style="padding: 0;max-height: 186px;overflow-y: auto" v-if="keywordList && keywordList.length">
                  {{ keywordList[0].technology }}
                </div>
                <div v-else style="color: #00000E45;font-size: 14px;padding-top: 10px">先在左侧输入内容，再点击「立即识别」，大模型将自动拆解您的需求～</div>
              </div>
              <div class="keyword-input">
                <div style="font-size: 14px;height: 14px;margin: 10px 0 6px;color: #181F33">关键词：</div>
                <div class="keyword-box" :style="{ maxHeight: keywordHeight + 'px' }">
                  <div
                    class="tag-item"
                    v-for="(tag,ind) in keywordTags"
                    :key="ind"
                    :style="{paddingRight: isEdit ? '16px' : '8px'}"
                  >
                    <span class="" v-if="!isEdit">{{ tag.tagName }}</span>
                    <el-input v-model="tag.tagName" size="mini" style="width: 88px" v-else />
                    <el-popconfirm
                      v-if="isEdit"
                      placement="top"
                      confirm-button-text='确认'
                      cancel-button-text='取消'
                      icon="el-icon-info"
                      icon-color="red"
                      popper-class="keyword-confirm-delete-gj"
                      title="确定删除吗？"
                      @confirm="handleTagClose(tag)"
                    >
                      <i class="el-icon-close" slot="reference"></i>
                    </el-popconfirm>
                  </div>
                  <div style="display: inline-block;height: 28px" v-if="isEdit">
                    <span class="flex items-center" style="flex-wrap: nowrap;height: 28px;" v-if="tagVisible">
                      <el-input
                        class="input-new-tag"
                        v-model.trim="tagValue"
                        ref="saveTagInput"
                        size="mini"
                        placeholder="请输入关键词"
                      />
                      <span class="operation-btn pointer" style="color: #3860F4;margin-left: 8px" @click="handleTagConfirm">确定</span>
                      <span class="operation-btn pointer" style="color: rgba(0,0,0,0.65)" @click="()=>{ tagValue = '';tagVisible = false; }">取消</span>
                    </span>
                    <span class="button-new-tag" @click="showInput" v-else>+ 添加</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 生成报告 -->
            <div class="goDetails-btn flex items-center justify-between" style="width: 100%;flex-shrink: 0">
              <div class="flex items-center update-btn no-wrap">
                请确保关键词是否正确？
                <el-button type="text" style="color: #3860F4" @click="handleEdit" :loading="updateLoading">{{ !isEdit ? '点击修改' : '点击保存' }}</el-button>
              </div>
              <span class="submit-btn">
                <el-button :loading="false" @click="goDetail">生成报告</el-button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="upload-btn-primary">
        <div style="height: 36px;" v-if="questionId"></div>
        <el-button :loading="keyWordLoading" @click="getDemandDisassembly" v-else>立即识别</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { requirementIndexMixin } from '@/mixin/requirementAnalysis/requirementMixin';

export default {
  name: 'requirementAnalysisGuoJiao',
  mixins: [ requirementIndexMixin ],
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {
    document.title = '需求分析';
  },
  methods: {}
};
</script>

<style scoped lang="less">
.requirement-analysis {
  width: 100%;
  min-height: 100vh; // calc(100vh - 62px)
  display: flex;
  justify-content: center;
  background-image: url("~@/assets/images/GuoJiao/bg.png");
  background-color: #D8E7FC;
  background-size: 100% 100%;
  background-position: 100% 100%;
  background-repeat: no-repeat;

  .title-box {
    display: flex;
    align-items: center;
    justify-content: center;
    .ai-icon {
      width: 53px;
      height: 52px;
      margin-right: 15px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/GuoJiao/ai-icon.png");
    }
    .title-icon {
      width: 228px;
      height: 43px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/GuoJiao/demand-title.png");
    }
  }

  .title-message {
    font-family: PingFang SC;
    margin-top: 18px;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    color: #181F33;
    letter-spacing: 1px;
    opacity: 0.85;
    user-select: none;
  }

  .content-bg {
    width: 1080px;
    height: 450px;
    box-sizing: border-box;
    margin-top: 30px;
    padding: 20px;
    border: 1px solid rgba(61, 123, 225, 0.2);
    border-radius: 12px;
    background: rgba(61, 123, 225, 0.2);
    box-shadow: 0px 2px 8px 0px rgba(6,40,86,0.06);

    .content-box {
      display: flex;
      justify-content: space-between;
      height: 100%;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 8px 0 rgba(6, 40, 86, 0.06);
    }

    .input-content {
      box-sizing: border-box;
      flex-shrink: 0;
      width: 50%;
      padding: 16px 20px 10px;
    }


    /deep/ .el-textarea {
      height: calc(100% - 40px);
    }

    /deep/ .el-textarea__inner {
      color: #181F33 !important;
      border: none;
      height: 100%;
      padding: 0;
      font-size: 16px !important;
      &::placeholder {
        color: #8191B2;
      }
    }
    .upload-file{
      width:  50%;
      height: calc(100% - 32px);
      padding: 17px 14px;
    }
    /deep/.upload-demo{
      height: 100%;
      width: 100%;
    }
    /deep/.el-upload{
      height: 100%;
      width: 100%;
    }
    /deep/.el-upload-dragger{
      height: 100%;
      width: 100%;
    }
    .upload_text{
      color: #000000;
      font-size: 16px;
      margin-top: 15px;
      span{
        color: #1072EC;
        cursor: pointer;
      }
    }
    .upload-line{
      font-size: 14px;
      color: #000000;
      opacity: 0.65;
      justify-content: center;
      display: flex;
      align-items: center;
      margin-top: 42px;
      div{
        width: 60px;
        height: 1px;
        margin: 0 14px;
        opacity: 0.65;
        background-color: #000000;
      }
    }
    .upload-img{
      margin-top: 20px;
      height: 22px;
      display: flex;
      width: 160px;
      justify-content: space-between;
    }
  }

  .goDetails-btn{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .update-btn {
      font-weight: 400;
      font-size: 13px;
      /deep/ .el-button {
        padding: 0 !important;
        margin-left: 4px;
        span {
          font-size: 13px;
          font-weight: 400;
        }
      }
    }
    .submit-btn {
      /deep/ .el-button {
        display: flex;
        align-items: center;
        font-size: 13px !important;
        padding: 7px 13px !important;
        justify-content: center;
        background: #fff;
        color: #3860F4;
        border-color: #3860F4;
        border-radius: 16px !important;
        span {
          font-weight: 400;
        }
      }
    }
  }

  .upload-btn {
    width: 100%;
    color: #00000E85;
    display: flex;
    justify-content: end;

    /deep/ .el-button {
      color: #FFFFFF;
      border: none;
      padding: 0;
      background: #3860F4;
      font-size: 13px !important;
      border-radius: 16px !important;
      span {
        font-weight: 400;
      }
    }
    div{
      width: 200px;
      height: 44px;
      background: #464BFE;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: white;
    }
  }

  .upload-btn-primary {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 25px;

    /deep/ .el-button {
      min-width: 100px;
      height: 36px;
      color: #ffffff;
      background: #3860F4;
      border: none;
      border-radius: 30px !important;
      //box-shadow: 0px -5px 12px 0px rgba(10,114,255,0.26), 0px 5px 12px 0px rgba(10,114,255,0.3);
    }
  }
}

/deep/.el-dialog{
  border-radius: 8px;
}

.update{
  /deep/.el-dialog{
    margin-top: 30vh !important;
  }
  /deep/.el-dialog__header{
    padding: 20px 20px 10px;
  }

  /deep/.el-dialog__body{
    padding: 20px 30px;
  }
}
/deep/.el-dialog__header{
  padding: 0;
}
/deep/.el-dialog__body{
  padding: 50px 30px;
}
.dialogTitle{
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 20px;
  color: #000000;
}

.item-data{
  background: #FFFFFF;
  border-radius: 4px;
  padding: 20px 22px;
  margin-top: 8px;
  border: 1px solid #DEE2E9;
  .fieldName{
    font-weight: 400;
    margin-left: 9px;
    font-size: 14px;
    color: #00000E65;
  }
  .field-keyword{
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #00000E65;
    margin-top: 20px;

    .keyword-item{
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #464BFE;
      padding: 6px 11px;
      font-weight: 400;
      font-size: 14px;
      color: #464BFE85;
      margin-right: 8px;
    }
  }
}
.goDetails{
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  width: 200px;
  height: 44px;
  display: flex;
  margin-top: 60px;
  align-items: center;
  justify-content: center;
  background: #464BFE;
  border-radius: 22px;
  cursor: pointer;
}
.tips-field{
  margin-top: 17px;
  font-size: 14px;
  color: #00000E85;
}

.field-content{
  font-weight: 400;
  padding: 14px 0;
  font-size: 16px;
  line-height: 24px;
  color: #50607F;
}

.keyword-input{
  .keyword-box {
    width: 100%;
    display: flex;
    align-items: start;
    flex-wrap: wrap;
    height: auto;
    //min-height: 98px;
    min-height: 58px;
    overflow-y: auto;
    overflow-x: hidden;
    /deep/ .el-tg {
      max-width: 400px;
      margin-right: 10px;
      color: #3860F4;
      border-color: #3860F4;
      padding: 0 8px;
      margin-bottom: 6px;
      background: #FFFFFF;
      .el-tag__close {
        color: #3860F4;
        &:hover {
          color: #fff;
          background: rgba(2, 38, 224, 0.7);
        }
      }
    }

    .tag-item {
      position: relative;
      max-width: calc(100% - 38px);
      flex-shrink: 0;
      color: #3860F4;
      font-size: 13px;
      height: 24px;
      line-height: 24px;
      border: 1px solid #3860F4;
      padding: 1px 20px 1px 6px;
      margin: 0 8px 10px 0;
      border-radius: 4px;
      background: #FFFFFF;
      span {
        display: inline-block;
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;

        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }
      }
      /deep/ .el-input__inner {
        font-size: 13px;
        height: 24px;
        line-height: 24px;
        padding: 0 !important;
        border: none;
      }
      .el-icon-close {
        position: absolute;
        right: 3px;
        top: 0;
        vertical-align: top;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        &:hover {
          color: #3860F4;
        }
      }
    }

    .button-new-tag {
      display: inline-block;
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      color: #3860F4;
      white-space: nowrap;
      cursor: pointer;

      /deep/ .el-button {
        height: 28px;
        line-height: 28px;
        padding: 0 !important;
        border: 1px solid red;
        border-radius: unset !important;
        span {
          font-size: 14px;
          color: #3860F4;
          font-weight: 400;
          white-space: nowrap;
        }
      }
    }
    .input-new-tag {
      width: 112px;
      /deep/ .el-input__inner {
        padding: 0 4px !important;
        &:focus {
          border-color: #3860F4;
        }
        &::placeholder {
          color: #999;
          font-size: 12px;
        }
      }
    }
    /deep/ .el-button {
      padding: 0 6px;
    }
    .operation-btn {
      font-size: 13px;
      line-height: 28px;
      margin-left: 4px;
    }
  }
  /deep/ .el-textarea {
    padding-top: 10px;
    height: 81px !important;

    /deep/ .el-textarea__inner {
      font-size: 12px !important;
    }
  }
}
</style>
